import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class RegistrationTooManyAttemptsError extends ExpectedError {
  static override _class = 'RegistrationTooManyAttemptsError';

  public constructor() {
    super('RegistrationTooManyAttemptsError', { translationKey: 'REGISTRATION_TOO_MANY_ATTEMPTS_ERROR' });
  }
}
